export const VIBE_LABELS: Record<number, string> = {
  2: "Very Bullish",
  1: "Bullish",
  0: "Mixed",
  "-1": "Bearish",
  "-2": "Very Bearish",
};

export const VIBE_EMOJI_LABELS: Record<number, string> = {
  2: "\u{1F680} Very Bullish",
  1: "\u{1F4C8} Bullish",
  0: "\u{1F610} Mixed",
  "-1": "\u{1F4C9} Bearish",
  "-2": "\u{1F480} Very Bearish",
};

export const VIBE_COLORS: Record<number, string> = {
  2: "text-vibe-very-bullish",
  1: "text-vibe-bullish",
  0: "text-vibe-mixed",
  "-1": "text-vibe-bearish",
  "-2": "text-vibe-very-bearish",
};

export const VIBE_BG_COLORS: Record<number, string> = {
  2: "bg-green-500",
  1: "bg-lime-500",
  0: "bg-yellow-500",
  "-1": "bg-orange-500",
  "-2": "bg-red-500",
};

export const HORIZON_LABELS: Record<number, string> = {
  1: "24+ months",
  2: "12\u201324 months",
  3: "6\u201312 months",
  4: "3\u20136 months",
  5: "< 3 months",
};

export const REASON_TAGS = [
  { value: "real_tech", label: "Real Tech" },
  { value: "fake_moat", label: "Fake Moat" },
  { value: "insane_founder_speed", label: "Insane Founder Speed" },
  { value: "distribution_monster", label: "Distribution Monster" },
  { value: "ai_wrapper", label: "AI Wrapper" },
  { value: "regulatory_risk", label: "Regulatory Risk" },
  { value: "enterprise_slog", label: "Enterprise Slog" },
  { value: "obvious_wedge", label: "Obvious Wedge" },
  { value: "crowded_space", label: "Crowded Space" },
  { value: "strong_team", label: "Strong Team" },
  { value: "tourist_energy", label: "Tourist Energy" },
  { value: "hard_problem_real_upside", label: "Hard Problem, Real Upside" },
  { value: "overhyped", label: "Overhyped" },
  { value: "underrated", label: "Underrated" },
];

export const FEED_TABS = [
  { value: "trending", label: "\u{1F525} Trending" },
  { value: "resilient", label: "\u{1F4AA} Resilient" },
  { value: "fragile", label: "\u{1F480} Fragile" },
  { value: "divisive", label: "\u2694\uFE0F Divisive" },
  { value: "newest", label: "\u2728 Newest" },
];

export const CATEGORY_COLORS: Record<string, string> = {
  ai_ml: "bg-violet-500/15 text-violet-300 border-violet-500/20",
  fintech: "bg-emerald-500/15 text-emerald-300 border-emerald-500/20",
  health_tech: "bg-rose-500/15 text-rose-300 border-rose-500/20",
  saas: "bg-blue-500/15 text-blue-300 border-blue-500/20",
  e_commerce: "bg-amber-500/15 text-amber-300 border-amber-500/20",
  edtech: "bg-cyan-500/15 text-cyan-300 border-cyan-500/20",
  climate_tech: "bg-green-500/15 text-green-300 border-green-500/20",
  consumer: "bg-pink-500/15 text-pink-300 border-pink-500/20",
  crypto_web3: "bg-orange-500/15 text-orange-300 border-orange-500/20",
  biotech: "bg-teal-500/15 text-teal-300 border-teal-500/20",
  hardware: "bg-slate-400/15 text-slate-300 border-slate-400/20",
  marketplace: "bg-yellow-500/15 text-yellow-300 border-yellow-500/20",
  developer_tools: "bg-indigo-500/15 text-indigo-300 border-indigo-500/20",
  security: "bg-red-500/15 text-red-300 border-red-500/20",
  enterprise: "bg-sky-500/15 text-sky-300 border-sky-500/20",
  social: "bg-fuchsia-500/15 text-fuchsia-300 border-fuchsia-500/20",
  gaming: "bg-purple-500/15 text-purple-300 border-purple-500/20",
  other: "bg-slate-500/15 text-slate-300 border-slate-500/20",
};

export function getCategoryColor(category: string): string {
  return (
    CATEGORY_COLORS[category] ||
    "bg-slate-500/15 text-slate-300 border-slate-500/20"
  );
}

export const VC_REASON_TAGS = [
  { value: "founder_friendly", label: "Founder Friendly" },
  { value: "spray_and_pray", label: "Spray & Pray" },
  { value: "smart_money", label: "Smart Money" },
  { value: "hype_machine", label: "Hype Machine" },
  { value: "deep_pockets", label: "Deep Pockets" },
  { value: "slow_to_close", label: "Slow to Close" },
  { value: "board_drama", label: "Board Drama" },
  { value: "value_add", label: "Value Add" },
  { value: "check_writer_only", label: "Check Writer Only" },
  { value: "early_believer", label: "Early Believer" },
  { value: "late_stage_tourist", label: "Late Stage Tourist" },
  { value: "governance_nightmare", label: "Governance Nightmare" },
  { value: "portfolio_support", label: "Portfolio Support" },
  { value: "quick_no", label: "Quick No" },
];

export const VC_FEED_TABS = [
  { value: "trending", label: "\u{1F525} Trending" },
  { value: "best_rated", label: "\u2B50 Top Rated" },
  { value: "worst_rated", label: "\u{1F480} Worst Rated" },
  { value: "most_controversial", label: "\u2694\uFE0F Controversial" },
  { value: "biggest_portfolio", label: "\u{1F4CA} Biggest Portfolio" },
  { value: "newest", label: "\u2728 Newest" },
];

export const VC_TYPE_COLORS: Record<string, string> = {
  vc: "bg-blue-500/15 text-blue-300 border-blue-500/20",
  accelerator: "bg-purple-500/15 text-purple-300 border-purple-500/20",
  angel: "bg-amber-500/15 text-amber-300 border-amber-500/20",
  corporate_vc: "bg-cyan-500/15 text-cyan-300 border-cyan-500/20",
  family_office: "bg-emerald-500/15 text-emerald-300 border-emerald-500/20",
  hedge_fund: "bg-rose-500/15 text-rose-300 border-rose-500/20",
};

export const VC_TYPE_LABELS: Record<string, string> = {
  vc: "VC",
  accelerator: "Accelerator",
  angel: "Angel",
  corporate_vc: "Corporate VC",
  family_office: "Family Office",
  hedge_fund: "Hedge Fund",
};

export const CONTROVERSY_SEVERITY_COLORS: Record<string, string> = {
  critical: "bg-red-500/15 text-red-400 border-red-500/25",
  high: "bg-orange-500/15 text-orange-400 border-orange-500/25",
  medium: "bg-yellow-500/15 text-yellow-400 border-yellow-500/25",
  low: "bg-slate-500/15 text-slate-400 border-slate-500/25",
};
